import { render } from "./VO2MaxCalculator.vue?vue&type=template&id=f611ffae&scoped=true"
import script from "./VO2MaxCalculator.vue?vue&type=script&lang=js"
export * from "./VO2MaxCalculator.vue?vue&type=script&lang=js"

import "./VO2MaxCalculator.vue?vue&type=style&index=0&id=f611ffae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f611ffae"]])

export default __exports__